import { escape } from "lodash";
import { BaseSyntheticEvent } from "react";
import { FieldValues } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { sanitizeReturnUrl } from "utils/sanitizeReturnUrl";

const signinPath = "/signin";

const passesApiReturnUrlCheck = (url: string) => {
	try {
		return decodeURIComponent(url) === url && encodeURI(escape(url)) === url;
	} catch {
		return false;
	}
};

const getDeepLink = (returnUrl: string | null) => {
	if (!returnUrl?.startsWith(`${signinPath}?`)) return returnUrl;

	const nestedReturnUrl = new URLSearchParams(
		returnUrl.slice(signinPath.length)
	).get("return_url");
	return sanitizeReturnUrl(nestedReturnUrl)?.url ?? null;
};

const getSigninUrl = (deepLink: string | null) => {
	const signinUrl = `${window.location.origin}${signinPath}`;
	if (!deepLink) return signinUrl;

	const signinUrlWithDeepLink = `${signinUrl}?return_url=${deepLink}`;
	return passesApiReturnUrlCheck(signinUrlWithDeepLink) ?
			signinUrlWithDeepLink
		:	signinUrl;
};

const useController = () => {
	const [searchParams] = useSearchParams();

	const deepLink = getDeepLink(
		sanitizeReturnUrl(searchParams.get("return_url"))?.url ?? null
	);

	const formAction = `${
		window.SAM._env_.REACT_APP_BASE_API_URL
	}/signin/sso?return_url=${encodeURIComponent(getSigninUrl(deepLink))}`;

	const errorMessage = searchParams.get("error");

	const misconfiguredParam = searchParams.get("misconfigured");
	const misconfiguredError = misconfiguredParam === "true";

	const emailMismatchParam = searchParams.get("email_mismatch");
	const emailMismatchError = emailMismatchParam === "true";

	const handleSubmit = (_data: FieldValues, event?: BaseSyntheticEvent) => {
		const form = event?.target as HTMLFormElement;
		form.action = formAction;
		form.method = "post";
		form.submit();
	};

	return { emailMismatchError, errorMessage, handleSubmit, misconfiguredError };
};

export default useController;
